import ProjectUserCardModule from './project-user-card.module'

export default ProjectUserCardModule
